/**
 * Hero atmosphere: slow-falling confetti + slow flying butterflies.
 * Pure CSS animations (no JS rAF loops) — see keyframes in index.css.
 */
const CONFETTI = [
  { x: "6%",  w: 8,  h: 14, color: "#FF8A5B", dur: 16, delay: -2,  dx: -18, rot: "540deg" },
  { x: "14%", w: 6,  h: 10, color: "#C89B5C", dur: 22, delay: -9,  dx: 26,  rot: "720deg" },
  { x: "22%", w: 9,  h: 6,  color: "#E3001B", dur: 18, delay: -14, dx: -10, rot: "900deg" },
  { x: "30%", w: 7,  h: 12, color: "#F4EBD9", dur: 24, delay: -5,  dx: 30,  rot: "-540deg" },
  { x: "38%", w: 10, h: 5,  color: "#FFD86B", dur: 20, delay: -12, dx: 14,  rot: "720deg" },
  { x: "46%", w: 6,  h: 14, color: "#FF8A5B", dur: 28, delay: -18, dx: -28, rot: "-720deg" },
  { x: "54%", w: 8,  h: 8,  color: "#1B4F72", dur: 19, delay: -6,  dx: 18,  rot: "540deg" },
  { x: "62%", w: 7,  h: 11, color: "#C89B5C", dur: 26, delay: -16, dx: -22, rot: "720deg" },
  { x: "70%", w: 9,  h: 6,  color: "#FFD86B", dur: 21, delay: -3,  dx: 24,  rot: "-540deg" },
  { x: "78%", w: 6,  h: 13, color: "#E3001B", dur: 17, delay: -11, dx: -16, rot: "900deg" },
  { x: "86%", w: 8,  h: 10, color: "#F4EBD9", dur: 23, delay: -7,  dx: 20,  rot: "720deg" },
  { x: "94%", w: 7,  h: 7,  color: "#FF8A5B", dur: 25, delay: -19, dx: -12, rot: "-720deg" },
  { x: "18%", w: 8,  h: 12, color: "#FFD86B", dur: 27, delay: -23, dx: 22,  rot: "540deg" },
  { x: "58%", w: 6,  h: 9,  color: "#F4EBD9", dur: 30, delay: -10, dx: -24, rot: "720deg" },
  { x: "82%", w: 9,  h: 6,  color: "#1B4F72", dur: 21, delay: -15, dx: 14,  rot: "-540deg" },
];

const BUTTERFLIES = [
  { top: "18%", dur: 48, delay: -3,  scale: 1,    accent: "#FF8A5B" },
  { top: "35%", dur: 72, delay: -32, scale: 0.75, accent: "#C89B5C" },
  { top: "55%", dur: 60, delay: -18, scale: 0.9,  accent: "#E3001B" },
];

function Butterfly({ accent = "#FF8A5B", scale = 1 }) {
  const w = 44 * scale;
  return (
    <svg
      className="butterfly-inner"
      width={w}
      height={w * 0.78}
      viewBox="0 0 44 34"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M22 17 Q6 3 2 14 Q4 24 14 26 Q19 23 22 17 Z"
        fill={accent}
        stroke="#0A2540"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M22 17 Q38 3 42 14 Q40 24 30 26 Q25 23 22 17 Z"
        fill={accent}
        stroke="#0A2540"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <ellipse cx="22" cy="17" rx="1.2" ry="7" fill="#0A2540" />
      <circle cx="22" cy="9.5" r="1.1" fill="#0A2540" />
      <circle cx="8" cy="11" r="1.1" fill="#FFFFFF" />
      <circle cx="36" cy="11" r="1.1" fill="#FFFFFF" />
    </svg>
  );
}

export default function HeroEffects() {
  return (
    <>
      {CONFETTI.map((c, i) => (
        <span
          key={`cf-${i}`}
          className="confetti-piece"
          style={{
            "--cf-x": c.x,
            "--cf-w": `${c.w}px`,
            "--cf-h": `${c.h}px`,
            "--cf-color": c.color,
            "--cf-dur": `${c.dur}s`,
            "--cf-delay": `${c.delay}s`,
            "--cf-dx": `${c.dx}px`,
            "--cf-rot": c.rot,
          }}
          aria-hidden
        />
      ))}
      {BUTTERFLIES.map((b, i) => (
        <div
          key={`bf-${i}`}
          className="butterfly"
          style={{
            "--bf-top": b.top,
            "--bf-dur": `${b.dur}s`,
            "--bf-delay": `${b.delay}s`,
          }}
          aria-hidden
        >
          <Butterfly accent={b.accent} scale={b.scale} />
        </div>
      ))}
    </>
  );
}
